import {Injectable} from '@angular/core';


import {ApiService} from "../api-service/api-service";
import {SaleItem} from "../../interface/sale-item";

@Injectable()
export class SaleService {
  defaultSale: SaleItem = {
    "id": "",
    "name": "",
    "dsp": "",
    "mail_fee": "0",
    "original_price": "248",
    "act_price": "0",
    "market_price": "350",
    "publishtime": 1513514379,
    "status": "normal",
    "images": [],
    "sale_total": "0",
    "servertime": 1513514379,
    "activity_id": 0,
    "brand_id": 0,
    "category_id": 0,
    "createtime": 0,
    "flag": "",
    "is_password": "off",
    "is_ready": "off",
    "ismark": 0,
    "leftnum": 0,
    "main_image": "assets/img/preload.jpg",
    "sale_sn": "",
    "tag_ids": "",
    "max_num": 0,
    "sort": 0,
    "total_num": 0,
    "skus": [],
  };

  constructor(public api: ApiService) {

  }

  //获取商品详情
  saleinfo(params?: any) {
    let seq = this.api.get('v1/sale', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }



  //获取随机推荐的商品
    getTjSales(params?: any) {
        params.id='tj';
    let seq = this.api.get('v1/sale/tj', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  //获取标签商品
  getTagSales(params?: any) {
    let seq = this.api.get('v1/tagsale', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  //获取品牌商品列表
  categorySale(params?: any) {
    let seq = this.api.get('v1/brand/sales', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }



  // v1/home
  getHomeLotterySale(params: any) {
    let seq = this.api.get('v1/home', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  //draw/sales
  getLotterySaleList(params: any) {
    let seq = this.api.get('v1/draw/sales', params).share();
    seq.subscribe((res: any) => {
      // console.log('draw/sales');
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // check code
  // draw/prize
  checkLotteryCode(params: any) {
    let seq = this.api.get('v1/draw/prize', params).share();
    seq.subscribe((res: any) => {
      // console.log('draw/prize');
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  getSaleSeckill(params: any) {
    let seq = this.api.get('v1/second/kill', params).share();
    seq.subscribe((res: any) => {
      // console.log('v1/second/kill');
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


  /**
   * http://www.overdose.com/api/sale.user_show?user_id=1&sale_id=10
   * @param params
   * @return {Observable<any>}
   */
  saleUserShowList(params: any) {
    let seq = this.api.get('api/sale.user_show', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  /**
   * 用户发布上身照
   * http://www.overdose.com/api/sale.user_show/add?&user_id=1
   * @param params
   * @return {Observable<any>}
   */
  saleUserShow(params?: any) {
    let seq = this.api.post('api/sale.user_show/add', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }
  // ---------------------------------- 新的商品详情 ------------------------
  /**
   * 新的商品详情
   * http://www.overdose.com/api/sale.show?user_id=1&sale_id=10
   * @param params
   * @return {Observable<any>}
   */
  saleShow(params?: any) {
    let seq = this.api.get('api/sale.show', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  // ---------------------------------- 商品喜欢收藏分享 ------------------------
  /**
   * 喜欢商品
   * http://www.overdose.com/v1/sale/like?&user_id=1&sale_id=10
   * @param params
   * @return {Observable<any>}
   */
  saleLike(params?: any) {
    let seq = this.api.get('v1/sale/like', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 收藏商品
   * http://www.overdose.com/v1/sale/favorite?user_id=1&sale_id=10
   * @param params
   * @return {Observable<any>}
   */
  saleFavorite(params?: any) {
    let seq = this.api.get('v1/sale/favorite', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }

  /**
   * 分享商品
   * http://www.overdose.com/v1/sale/share?user_id=1&sale_id=10
   * @param params
   * @return {Observable<any>}
   */
  saleShare(params?: any) {
    let seq = this.api.get('v1/sale/share', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });
    return seq;
  }


  // ---------------------------------- 商品评论 ------------------------
  /**
   * 获取商品评论
   * @param params
   * @return {Observable<any>}
   */
  getSaleComment(params?: any) {
    let seq = this.api.get('v1/comment', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 发布商品评论
   * @param params
   * @return {Observable<any>}
   */
  postComment(params?: any) {
    let seq = this.api.post('v1/comment', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  /**
   * 删除商品评论
   * @param params
   * @return {Observable<any>}
   */
  deleteComment(params?: any) {
    params.id = 'delete';
    let seq = this.api.get('v1/comment/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service/sale-service.ts